import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { House } from "@phosphor-icons/react";

export default function Login() {
    const { login, error } = useAuth();
    const [email, setEmail] = useState("admin@terracrm.com");
    const [password, setPassword] = useState("admin123");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    async function onSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const ok = await login(email, password);
        setLoading(false);
        if (ok) navigate("/");
    }

    return (
        <div className="min-h-screen flex">
            <div
                className="hidden md:flex md:w-1/2 bg-cover bg-center relative"
                style={{
                    backgroundImage:
                        "url(https://static.prod-images.emergentagent.com/jobs/6c3c7649-75b7-40bc-82e6-aa1aa2b86132/images/f96c55f9a15e5214fd45ba8dafd662cf0d7eeb9dc328c3fcbc1e15714ab4dd54.png)",
                }}
            >
                <div className="absolute inset-0 bg-gradient-to-br from-ink/40 to-transparent" />
                <div className="relative z-10 p-12 self-end text-white">
                    <p className="text-xs uppercase tracking-[0.3em] mb-3 opacity-80">Terra CRM</p>
                    <h2 className="font-display text-4xl font-bold leading-tight max-w-md">
                        Suivi des terrains, contrats et paiements en toute clarté.
                    </h2>
                </div>
            </div>

            <div className="flex-1 flex items-center justify-center p-8 bg-cream">
                <div className="w-full max-w-md fade-up">
                    <div className="flex items-center gap-3 mb-8">
                        <div className="w-12 h-12 rounded-xl bg-terracotta text-white grid place-items-center">
                            <House weight="fill" size={24} />
                        </div>
                        <div>
                            <h1 className="font-display text-2xl font-bold text-ink">Terra CRM</h1>
                            <p className="text-sm text-ink-soft">Gestion immobilière</p>
                        </div>
                    </div>

                    <h2 className="font-display text-3xl font-bold text-ink mb-2">Bienvenue</h2>
                    <p className="text-ink-soft mb-8">Connectez-vous à votre espace.</p>

                    <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
                        <div>
                            <Label htmlFor="email">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="mt-1.5 bg-white"
                                data-testid="login-email-input"
                                required
                            />
                        </div>
                        <div>
                            <Label htmlFor="password">Mot de passe</Label>
                            <Input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="mt-1.5 bg-white"
                                data-testid="login-password-input"
                                required
                            />
                        </div>

                        {error && (
                            <p className="text-sm text-destructive" data-testid="login-error">
                                {error}
                            </p>
                        )}

                        <Button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-terracotta hover:bg-terracotta-dark text-white py-6 rounded-md font-medium active:translate-y-[1px] transition-all"
                            data-testid="login-submit-button"
                        >
                            {loading ? "Connexion…" : "Se connecter"}
                        </Button>

                        <p className="text-xs text-ink-soft text-center pt-2">
                            Identifiants par défaut affichés ci-dessus.
                        </p>
                    </form>
                </div>
            </div>
        </div>
    );
}
